import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'idValue', pure: true })
export class IdValuePipe implements PipeTransform {

  transform(id: number, idValues: Map<number,string>): string {
    return idValues.get(id);
  }

}
